class HHGalleryZoom extends HTMLElement {
  constructor() {
    super()

    this.triggers = this.querySelectorAll('.js-media-zoom')
    this.handleClick = this.handleClick.bind(this)
  }

  connectedCallback() {
    this.triggers.forEach((el) => {
      el.addEventListener('click', this.handleClick)
    })
  }

  disconnectedCallback() {
    this.triggers.forEach((el) => {
      el.removeEventListener('click', this.handleClick)
    })
  }

  handleClick(e) {
    const index =
      e.currentTarget.dataset.index ??
      document.querySelector('.js-product-media-main').current

    e.currentTarget.dispatchEvent(
      new CustomEvent('openDrawer', {
        bubbles: true,
        composed: true,
        detail: {
          key: 'media-zoom',
          event: e,
          index: index,
        },
      })
    )
  }
}

customElements.define('hh-gallery-zoom', HHGalleryZoom)
